export interface GetDateRangeModels {
    fromDate: Date,
    toDate: Date
}

export const GetDateRangeType = {
    today: 'today',
    yesterday: 'yesterday',
    thisMonth: 'this month',
    lastMonth: 'last month',
    last7Days: 'last 7 days',
    last15Days: 'last 15 days',
    last30Days: 'last 30 days',
    last60Days: 'last 60 days',
    last90Days: 'last 90 days',
    custom: 'custom',
    postingPeriod: 'postingPeriod',
    all: 'all',
    thisWeek: 'this week',
    thisWeekToDate: 'this week to date',
    thisMonthToDate: 'this month to date',
    thisQuarter: 'this quarter',
    thisQuarterToDate: 'this quarter to date',
    thisYear: 'this year',
    thisYearToLastMonth: 'this year to last month',
    thisyeartodate: 'this year to date',
    lastWeek: 'last week',
    lastWeekToDate: 'last week to date',
    lastMonthToDate: 'last month to date',
    lastQuarter: 'last quarter',
    lastQuarterToDate: 'last quarter to date',
    lastYear: 'last year',
    lastYearToDate: 'last year to date',
} as const;
export type typeGetDateRangeType = typeof GetDateRangeType[keyof typeof GetDateRangeType];

export const DateFilterType = {
    asOfDate: "AsOfDate",
    custom: "Custom",
}
